<template>
  <div class="internal-thread__container">
    <!-- Activity Communications Start-->
    <section name="activity" class="mt-3">
      <label class="internal-thread__text--header"
        >Activity Communication</label
      >
      <div
        v-for="(activity, index) in activityCommunityList"
        :key="index"
        class="detail__container"
      >
        <div class="d-flex w-100 justify-content-between">
          <div class="d-flex flex-column">
            <label class="detail__text--name">
              (#{{ index + 1 }}) {{ activity.name }}
              <span
                v-if="activity.name === userFullName"
                class="text-color-grey text-size-12"
              >
                [You]
              </span>
            </label>
            <label class="detail__text--detail mb-0">{{
              activity.detail
            }}</label>
          </div>
          <div class="d-flex flex-column align-items-end pl-1">
            <label class="detail__text--datetime text-right">{{
              activity.datetime
            }}</label>
          </div>
        </div>
        <div>
          <atom-file-attachment-list
            :attachmentList="activity.attachments"
            :isCheckOwnerPermissionDelete="true"
            :isDeletable="status !== 'CLOSED'"
            @onRequestDeleteAttachment="
              onRequestDeleteAttachment($event, activity)
            "
          ></atom-file-attachment-list>
        </div>
      </div>
    </section>

    <section name="reply-activity" class="mb-3">
      <div v-if="!isReplyActivity">
        <div
          :class="[
            status !== 'CLOSED'
              ? 'reply-detail__container'
              : 'reply-detail__container-disabled',
          ]"
          @click="status !== 'CLOSED' ? (isReplyActivity = true) : null"
        >
          <feather-icon
            class="icon-size-24px"
            :class="[status !== 'CLOSED' ? ' text-primary' : 'text-disabled']"
            icon="PlusCircleIcon"
          ></feather-icon>
          <span
            :class="[
              status !== 'CLOSED'
                ? 'reply-detail__text'
                : 'reply-detail__text-disabled',
            ]"
            >Reply</span
          >
        </div>
      </div>
      <div v-else>
        <div class="reply-detail-add__container">
          <div class="reply-detail__input-message w-100">
            <atom-text-area
              v-model="activity.message"
              placeholder="Message"
              :isError="isErrorActivity"
              :isResizable="true"
              errorMessage="Please enter message"
            ></atom-text-area>
          </div>
          <div class="reply-detail__select-file">
            <atom-file-attachment-input
              id="externalThreadAttachment"
              title="Attachments (Max. 25Mb)"
              @onUpdateFile="onUpdateThreadAttachment"
            ></atom-file-attachment-input>
          </div>
          <div class="reply-detail__button w-100">
            <atom-button
              buttonId="reply-detail__add"
              :isOnlyIcon="true"
              iconLeft="CheckIcon"
              class="add__button"
              @click="onclickAddActivity"
            ></atom-button>
            <atom-button
              buttonId="reply-detail__cancel"
              :isOnlyIcon="true"
              iconLeft="XIcon"
              buttonStyle="border"
              buttonColor="secondary"
              @click="onClickCloseActivity"
            ></atom-button>
          </div>
        </div>
      </div>
    </section>
    <!-- Activity Communications End-->

    <!-- Modal Start -->
    <section name="modal">
      <molecule-modal-dialog
        modalId="ticket-detail__confirm-edit-activity"
        :isTextCenter="true"
        textTitle="Do you want to add activity communications?"
        buttonTextLeft="Confirm"
        @clickButtonLeft="clickConfirmSaveEditActivity"
      ></molecule-modal-dialog>

      <molecule-modal-dialog
        modalId="ticket-detail__confirm-cancel-edit-activity"
        :isTextCenter="true"
        :textTitle="`Do you want to leave\nwithout finishing?`"
        buttonTextLeft="Confirm"
        buttonTextRight="Cancel"
        @clickButtonLeft="clickConfirmCancelEditActivity"
      ></molecule-modal-dialog>
    </section>
    <!-- Modal End-->
  </div>
</template>

<script>
import { BButtonGroup, BButton } from "bootstrap-vue"
import AtomTextArea from "@/components/atoms/AtomTextArea.vue"
import AtomFileAttachmentInput from "@/components/atoms/AtomFileAttachmentInput.vue"
import AtomCheckbox from "@/components/atoms/AtomCheckbox.vue"
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import AtomFileAttachmentList from "@/components/atoms/AtomFileAttachmentList.vue"
import { mapGetters } from "vuex"
import mixinsValidator from "@/mixins/mixinsValidator"

export default {
  name: "MoleculeExternalThread",
  components: {
    AtomTextArea,
    AtomFileAttachmentInput,
    BButtonGroup,
    BButton,
    AtomCheckbox,
    AtomSelect,
    AtomButton,
    MoleculeModalDialog,
    AtomFileAttachmentList,
  },
  props: {
    status: {
      type: String,
      required: true,
    },
    activityCommunityList: {
      type: Array,
      required: true,
    },
  },
  mixins: [mixinsValidator],
  emit: ["onClickAddTicketActivity"],
  data() {
    return {
      // activity communications
      isReplyActivity: false,
      isValidateActivity: false,
      isErrorActivity: false,

      activity: {
        message: null,
        attachment: null,
        isCloseTicket: false,
      },
    }
  },
  computed: {
    ...mapGetters("appPermission", ["getFullName"]),
    userFullName() {
      return this.getFullName
    },
  },
  watch: {
    activity: {
      deep: true,
      handler() {
        if (this.isValidateActivity) this.validateActivity()
      },
    },
  },
  methods: {
    // click file
    onClickFile(attachment) {
      window.open(attachment.path, attachment.fileName)
    },

    // activity
    onclickAddActivity() {
      this.isValidateActivity = true
      this.validateActivity()

      if (!this.isErrorActivity) {
        this.modalId = "ticket-detail__confirm-edit-activity"
        this.openModal(this.modalId)
      }
    },
    clickConfirmSaveEditActivity() {
      const addTicketActivity = {
        ...this.activity,
      }

      this.$emit("onClickAddTicketActivity", addTicketActivity)

      this.isReplyActivity = false
      this.setActivityToOrigin()

      this.closeModal()
    },
    onClickCloseActivity() {
      this.modalId = "ticket-detail__confirm-cancel-edit-activity"
      this.openModal(this.modalId)
    },
    clickConfirmCancelEditActivity() {
      this.isReplyActivity = false
      this.setActivityToOrigin()

      this.closeModal()
    },
    setActivityToOrigin() {
      this.isValidateActivity = false
      this.isErrorActivity = false
      this.activity = {
        message: null,
        attachment: null,
        isCloseTicket: false,
      }
    },

    // modal
    openModal(id) {
      this.modalId = id
      this.$bvModal.show(this.modalId)
    },
    // close modal
    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = null
    },

    // validate
    validateActivity() {
      if (!this.activity.message || this.isEmptyString(this.activity.message)) this.isErrorActivity = true
      else this.isErrorActivity = false
    },

    onUpdateThreadAttachment(fileList) {
      this.activity.attachment = fileList
    },

    onRequestDeleteAttachment(file, thread) {
      this.$emit("onRequestDeleteAttachment", file, thread)
    },
  },
}
</script>

<style lang="scss" scoped>
.internal-thread__text--header {
  margin: 0;
  color: #6e6b7b;
  font-weight: 500;
  font-size: 14px;
}

section[name="detail"],
section[name="activity"] {
  .detail__container {
    margin: 10px 0 0 0;
    padding: 1rem;
    width: 100%;
    background: #ffffff;
    border: 1px solid #ebe9f1;
    border-radius: 5px;
  }

  .detail__text--name {
    color: #5e5873;
    font-weight: 600;
    font-size: 14px;
  }

  .detail__text--detail {
    white-space: pre-wrap;
    word-break: break-word;
    max-width: 650px;
  }

  .detail__text--detail,
  .detail__text--datetime {
    color: #6e6b7b;
    font-size: 14px;
  }

  .detail__text--datetime {
    min-width: 140px;
  }

  .detail__text--attachment {
    color: #7367f0;
    font-size: 12px;
    text-decoration-line: underline;
    cursor: pointer;
  }

  @media screen and (min-width: 768px) {
    .detail__container {
      width: 650px;
    }
  }
}

section[name="reply-activity"] {
  .reply-detail__container {
    margin: 10px 0 1rem 0;
    padding: 1rem;
    width: 100%;
    background: #ffffff;
    border: 1px dashed rgba(115, 103, 240, 0.4);
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &:hover {
      background-color: #f9f9fe;
    }
  }

  .reply-detail__container-disabled {
    margin: 10px 0 1rem 0;
    padding: 1rem;
    width: 100%;
    background: #ffffff;
    border: 1px dashed #c9ccd1;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .reply-detail-add__container {
    margin: 10px 0 1rem 0;
    width: 100%;
  }

  .reply-detail__text {
    margin-left: 10px;
    color: #7367f0;
    font-weight: 600;
    font-size: 12px;
    cursor: pointer;
  }

  .reply-detail__text-disabled {
    margin-left: 10px;
    color: #c9ccd1;
    font-weight: 600;
    font-size: 12px;
  }

  .text-disabled {
    color: #c9ccd1;
  }

  .reply-detail__select-file {
    margin: 10px 0 0 0;
  }

  .reply-detail__sent-to {
    margin: 10px 0 0 0;
  }

  .sent-to__container {
    display: flex;
    flex-direction: column;
  }

  .sent-to__text-sent-to {
    min-width: 215px;
    font-size: 12px;
    color: #6e6b7b;
  }

  .sent-to__state {
    margin: 10px 0 0 0;
  }

  .sent-to__text-department,
  .sent-to__text-person {
    min-width: 100px;
    color: #6e6b7b;
    font-size: 12px;
  }

  .reply-detail__button {
    margin: 10px 0 0 0;
    display: flex;
    justify-content: flex-end;
  }

  @media screen and (min-width: 768px) {
    .reply-detail__container,
    .reply-detail__container-disabled,
    .reply-detail-add__container {
      width: 650px;
    }

    .sent-to__container {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  }
}

.add__button {
  margin-right: 10px;
}
</style>
